import React from 'react';
import { Image, Text, View } from 'react-native-web';
import {
  credit_card_es,
  getSubCategoryId,
  money_amount_148,
  Your_Bills,
} from '../../../../utils/DictionaryManagementUtils';
import { img_icon_add_circle } from '../../../../utils/ImagesManagementUtils';
import BillListComponent from '../../AuxiliaryComponent/AmountSim/BillListComponent';
import AccountBalance from '../../AuxiliaryComponent/AmountSim/AccountBalance';
import FullPageSimulator from '../FullPageSimulator';
import LargeBtnWithFilling from '../../AuxiliaryComponent/ButtonComponent/LargeBtnWithFilling';
import { textPrimary_10_3 } from '../../AuxiliaryComponent/TextComponent/TextStyle';

//= ========================================================================
const SelectBillFP = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  withEnterBtn = false,
  TopTitle,
  slideshowRefs,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { select_bill } = globJSON.configurations.services[subCategoryId];
  const { colors } = globJSON.configurations.theme;
  const isShowBalance = select_bill.show_account_balance;
  const isEnableEnterBill = select_bill.enable_customer_to_bill_code_manually;
  const myStyles = {
    yourBillsLineStyle: {
      marginTop: withEnterBtn ? -10 : 4,
      marginBottom: 4,
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingHorizontal: 20,
      alignItems: 'center',
      height: 20,
    },
    containerAmountComponent: {
      alignItems: 'center',
    },
    img_icon_add: {
      width: 12,
      height: 12,
      backgroundColor: colors.app_background_color,
      tintColor: colors.links_icons_color,
    },
    scrollViewStyle: {
      width: 220,
      paddingVertical: 8,
      alignSelf: 'center',
      flexDirection: 'column',
      backgroundColor: colors.app_background_color,
    },
    marginTop: {
      marginTop: -10,
    },
  };
  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      headlineText={select_bill.your_bills}
      TopTitle={TopTitle}
      slideshowRefs={slideshowRefs}
      floatingChildrenTop={(
          withEnterBtn && (
          <View style={myStyles.yourBillsLineStyle}>
            <Text style={textPrimary_10_3(globJSON, simPlatform)}>{Your_Bills}</Text>
            {isEnableEnterBill && (
            <Image
              fadeDuration={0}
              style={myStyles.img_icon_add}
              source={img_icon_add_circle}
            />
            )}
          </View>
          )
)}
    >
      {isShowBalance && !withEnterBtn && (
        <AccountBalance
          globJSON={globJSON}
          showExpendBox
          simPlatform={simPlatform}
        />
      )}
      {!withEnterBtn && (
      <View style={myStyles.yourBillsLineStyle}>
        <Text style={textPrimary_10_3(globJSON, simPlatform)}>{Your_Bills}</Text>
        {isEnableEnterBill && (
        <Image
          fadeDuration={0}
          style={myStyles.img_icon_add}
          source={img_icon_add_circle}
        />
        )}
      </View>
      )}
      <BillListComponent
        globJSON={globJSON}
        language={language}
        simPlatform={simPlatform}
        subCategoryId={subCategoryId}
        marginTop={withEnterBtn && -6}
      />
      <BillListComponent
        globJSON={globJSON}
        language={language}
        simPlatform={simPlatform}
        subCategoryId={subCategoryId}
        amount={money_amount_148}
        address={credit_card_es}
      />
      <View style={myStyles.containerAmountComponent}>
        {isEnableEnterBill && withEnterBtn
                && (
                <LargeBtnWithFilling
                  globJSON={globJSON}
                  simPlatform={simPlatform}
                  subCategoryId={subCategoryId}
                  inputText={select_bill.insert_another_bill}
                />
                )}
      </View>
    </FullPageSimulator>
  );
};

export default SelectBillFP;
